import api from "@/api/appSettings";

// initial state
const state = {
    all: [],
    setting: {}
};

// getters
const getters = {
    settings: state => state.all,
    setting: state => state.setting
};

// actions
const actions = {
    getSettings: async ({ commit }) => {
        const result = await api.getSettings();
        commit("setSettings", result.data);
        return result.data;
    },
    getSetting: async ({ commit }, id) => {
        const result = await api.getSetting(id);
        commit("setSetting", result.data);
        return result.data;
    },
    getSettingByKey: async ({ commit }, key) => {
        const result = await api.getSettingByKey(key);
        commit("setSetting", result.data);
        return result.data;
    },
    postSetting: async ({ commit }, setting) => {
        const result = await api.postSetting(setting);
        commit("addSetting", result.data);
        return result.data;
    },
    putSetting: async ({ commit }, setting) => {
        const result = await api.putSetting(setting);
        commit("updateSetting", result.data);
        return result.data;
    },
    deleteSetting: async ({ commit }, id) => {
        await api.deleteSetting(id);
        commit("removeSetting", id);
    }
};

// mutations
const mutations = {
    setSettings(state, settings) {
        state.all = settings;
    },
    setSetting(state, setting) {
        state.setting = Object.assign({}, setting);
    },
    addSetting(state, setting) {
        state.all.push(setting);
    },
    updateSetting(state, setting) {
        const index = state.all.findIndex(s => s.id === setting.id);
        if (index !== -1) {
            state.all.splice(index, 1, setting);
        }
    },
    removeSetting(state, id) {
        const index = state.all.findIndex(s => s.id === id);
        if (index !== -1) {
            state.all.splice(index, 1);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

